import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Buttton, Header, Inputs, Sides } from "../../../components";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { useAlert, useToast } from "../../../contexts";
const InvoicesSetting = ({ loginData }) => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [credentials, setCredentials] = useState({
    doctorName: "",
    DoctorGuid: null,
    ClinicGuid: null,
    clinicName: "",
    clinicAddress: "",
    doctorregistrationnumber: "",
    emailaddress: "",
    phoneNumber: "",
    invoiceId: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (loginData) {
      dispatch(
        actionDoctor.getInvoiceSettingByGuid(
          loginData?.userGuid,
          loginData?.clinicGuid
        )
      );
    }
  }, []);

  const getInvoiceSettingByGuidData = useSelector(
    (state) => state.doctor.getInvoiceSettingByGuidData?.data
  );


  useEffect(() => {
    if (getInvoiceSettingByGuidData?.success) {
      const data = getInvoiceSettingByGuidData.result[0];

      setCredentials({
        doctorName: data.doctorName,
        DoctorGuid: data.doctorGuid,
        ClinicGuid: data.clinicGuid,
        clinicName: data.clinicName,
        clinicAddress: data.clinicAddress,
        doctorregistrationnumber: data.doctorRegistrationNumber,
        emailaddress: data.emailAddress,
        phoneNumber: data.phoneNumber,
        invoiceId: data.invoiceSettingGuid,
      });
    }
  }, [getInvoiceSettingByGuidData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(
      actionDoctor.postSaveInvoiceSetting(credentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  `${t("Invalid_credentials")}`,
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            if (loginData) {
              dispatch(
                actionDoctor.getInvoiceSettingByGuid(
                  loginData?.userGuid,
                  loginData?.clinicGuid
                )
              );
            }
            showToast(
              t("success"),
              t("invoice_settings.update_success"),
              5000,
              true,
              "top-center toast-success"
            );
          }
        }
      })
    );
  };
  const rightSide = (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage pageHeading={t("invoice_settings.invoices_setting")} />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <section className="invoice-setting-section">
            <Form onSubmit={handleSubmit} className="invoice-setting-form">
              <Row>
                <Inputs.FormInputs
                  label={
                    errors.doctorName ? (
                      <span className="error-message">
                        {" "}
                        {errors.doctorName}
                      </span>
                    ) : (
                      t("specialist_name")
                    )
                  }
                  md={6}
                  placeholder="Specialist name"
                  value={credentials.doctorName}
                  name="doctorName"
                  onChange={handleChange}
                  grpClassname={`form-group  ${errors.doctorName ? "form-group-error" : ""
                    }`}
                />
                <Inputs.FormInputs
                  label={
                    errors.clinicName ? (
                      <span className="error-message">
                        {" "}
                        {errors.clinicName}
                      </span>
                    ) : (
                      t("clinics_names")
                    )
                  }
                  md={6}
                  placeholder="Clinics name"
                  value={credentials.clinicName}
                  name="clinicName"
                  onChange={handleChange}
                  grpClassname={`form-group mt-md-0 mt-3 ${errors.clinicName ? "form-group-error" : ""
                    }`}
                />
              </Row>
              <Row className="is-row">
                <Inputs.FormInputs
                  label={
                    errors.doctorregistrationnumber ? (
                      <span className="error-message">
                        {" "}
                        {errors.doctorregistrationnumber}
                      </span>
                    ) : (
                      t("doctors_registration_number")
                    )
                  }
                  placeholder={t("doctors_registration_number")}
                  md={6}
                  value={credentials.doctorregistrationnumber}
                  name="doctorregistrationnumber"
                  onChange={handleChange}
                  grpClassname={`form-group ${errors.doctorregistrationnumber ? "form-group-error" : ""
                    }`}
                />
              </Row>
              <Row className="is-row1">
                <Form.Label className="exado-title-seven is-row-lable">
                  {t("profile_page.additional_information.Practise_Contact_Information")}
                </Form.Label>
                <Inputs.FormInputs
                  label={
                    errors.emailaddress ? (
                      <span className="error-message">
                        {" "}
                        {errors.emailaddress}
                      </span>
                    ) : (
                      `${t("email")} ${t("Address")}`
                    )
                  }
                  md={6}
                  placeholder={`${t("email")} ${t("Address")}`}
                  value={credentials.emailaddress}
                  name="emailaddress"
                  onChange={handleChange}
                  grpClassname={`form-group ${errors.emailaddress ? "form-group-error" : ""
                    }`}
                />
                <Inputs.FormInputs
                  label={
                    errors.phoneNumber ? (
                      <span className="error-message">
                        {" "}
                        {errors.phoneNumber}
                      </span>
                    ) : (
                      t("phone_number")
                    )
                  }
                  md={6}
                  placeholder={t("phone_number")}
                  value={credentials.phoneNumber}
                  name="phoneNumber"
                  onChange={handleChange}
                  grpClassname={`form-group ${errors.phoneNumber ? "form-group-error" : ""
                    }`}
                />
              </Row>
              <Row className="is-row">
                <Inputs.FormInputs
                  label={
                    errors.clinicAddress ? (
                      <span className="error-message">
                        {" "}
                        {errors.clinicAddress}
                      </span>
                    ) : (
                      t("profile_page.additional_information.Street_Name_and_Door_Number"))
                  }
                  placeholder={t("profile_page.additional_information.Street_Name_and_Door_Number")}
                  value={credentials.clinicAddress}
                  name="clinicAddress"
                  onChange={handleChange}
                  grpClassname={`form-group ${errors.clinicAddress ? "form-group-error" : ""
                    }`}
                />
              </Row>

              <Row className="is-row1">
                <Col className="isbtnrow">
                  <Buttton.Buttton
                    children={t("CANCEL")}
                    className="btn-border-Aqua_Teal"
                  />
                  <Buttton.Buttton
                    type="submit"
                    children={t("save")}
                    className="btn-solid-Aqua_Teal"
                  />
                </Col>
              </Row>
            </Form>
          </section>
        </Col>
      </Row>
    </Container>
  );
  return (
    <AppLayout.AppLayoutOne
      leftSide={<Sides.LeftSides loginData={loginData} />}
      rightSide={rightSide}
    />
  );
};

export default InvoicesSetting;
